var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"centered-column"},[_c('div',{staticClass:"centered"},[_c('router-link',{attrs:{"to":"/slides/2"}},[_vm._v("Go to Slide 1")]),_c('a',{attrs:{"href":"http://avalia.io"}},[_vm._v("Go to Avalia website")]),_c('a',{attrs:{"href":"http://localhost:3000/#/slides/2"}},[_vm._v("Externalized internal link")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }